
export const CONTAINER_WIDTH = 30; // rem
export const CONTAINER_MAX_HEIGHT = 40; // rem
export const SUB_LIGHTBOX_TOP_OFFSET = 5; // px

// Z-index values
export const Z_INDEX_BASE = 1000;
export const Z_INDEX_SUB_LIGHTBOX = 1001;

// Visual
export const BOX_SHADOW = '0px 4px 20px rgba(0, 0, 0, 0.15)';
export const SKELETON_HEIGHT = 10; // rem

 
